import { CloseIcon as Close, InfoOutlinedIcon } from "@l2r-front/l2r-icons"
import {
    Chip as UiChip,
    IconButton as UiIconButton,
    Paper,
    ThresholdBottomSheet,
    Typography,
    styled,
    styledForMobile,
} from "@l2r-front/l2r-ui"

const DESKTOP_CONTAINER_WIDTH = 275

export const BottomSheet = styled(ThresholdBottomSheet)(({ theme }) => ({
    zIndex: theme.zIndex.modal + 1,
}))

export const Container = styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius: theme.spacing(8),
    padding: theme.spacing(8),
    height: `calc(100% - ${theme.spacing(8)})`,
    width: DESKTOP_CONTAINER_WIDTH,
}))

export const Header = styledForMobile("div")(({ theme, isMobile }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: isMobile ? "flex-start" : "space-between",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(8),
}))

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    height: 28,
    width: 28,
}))

export const IconButton = styled(UiIconButton)(() => ({
    padding: 0,
}))

export const CloseIcon = styled(Close)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    height: 24,
    width: 24,
}))

export const Content = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    overflowY: "auto",
}))

export const InfoRow = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
}))

export const InfoRowTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/secondary"].main,
}))

export const FormatDateWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
}))

export const InfoFormat = styled(Typography)(() => ({
    textTransform: "uppercase",
}))

export const TypeIcon = styled("img")(() => ({
    height: 16,
    width: 16,
    objectFit: "contain",
}))

export const AttachmentIconWrapper = styled("div")(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    height: 16,
    width: 16,
}))

export const RowContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
}))

export const Chip = styled(UiChip)(({ theme }) => ({
    backgroundColor: theme.palette.primary.contrast,
    border: `1px solid ${theme.palette.divider}`,
    width: "fit-content",

    "& > .MuiChip-label": {
        color: theme.palette["text/secondary"].main,
    },
}))

export const TagsList = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
}))

export const InfoContentContainer = styledForMobile("div")(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: isMobile && theme.spacing(0, 3),
}))